// extracted by mini-css-extract-plugin
export var wrap = "SectionBody-module--wrap--RzSUM";
export var noTopContent = "SectionBody-module--noTopContent--akGZl";
export var top = "SectionBody-module--top--Go8rc";
export var bottom = "SectionBody-module--bottom--TV9GD";
export var image = "SectionBody-module--image--bXVEM";
export var imgRight = "SectionBody-module--imgRight--YcLFN";
export var imgLeft = "SectionBody-module--imgLeft--1aR4g";
export var lg = "SectionBody-module--lg--J8HJv";